import React from 'react';
import styled from 'styled-components';
import { colors, InfoIcon, LockIcon, SwitchStyled, Typography } from '@commonsku/styles';
import ReactTooltip from 'react-tooltip';

type PodLockedToggleProps = {
  label: string;
  tooltipId: string;
  tooltipText: string;
  explanation?: React.ReactNode;
  dataTestId?: string;
};

const Row = styled.div`
  display: flex;
  align-items: center;
`;

const Title = styled(Typography.Text)`
  &&& {
    margin: 0;
    padding-right: 24px;
    line-height: 1.2;
  }
`;

const DisabledSwitch = styled.div`
  display: flex;
  align-items: center;
  opacity: 0.45;
  cursor: not-allowed;
  pointer-events: none;
`;

const InfoWrap = styled.div`
  display: inline-flex;
  align-items: center;
  margin-left: 8px;
  line-height: 0;
  cursor: help;

  svg {
    pointer-events: none;
    vertical-align: middle;
  }
`;

const TooltipContent = styled.div`
  display: flex;
  gap: 8px;
  align-items: flex-start;
  max-width: 280px;
  line-height: 1.4;
`;

const LockWrap = styled.span`
  display: flex;
  flex-shrink: 0;
  width: 16px;
  height: 16px;
  justify-content: center;
  align-items: center;
`;

/**
 * On + locked switch for PoD-forced checkout settings.
 */
const PodLockedToggle = ({
  label,
  tooltipId,
  tooltipText,
  explanation,
  dataTestId,
}: PodLockedToggleProps) => (
  <>
    <div className="small-12 columns">
      <Row>
        <Title fontSize="20px" bold>
          {label}
        </Title>
        <DisabledSwitch>
          <SwitchStyled
            size="medium"
            selected
            onClick={() => undefined}
            data-testid={dataTestId}
            aria-disabled="true"
          />
        </DisabledSwitch>
        <InfoWrap data-tip data-for={tooltipId} aria-label="Locked setting information">
          <InfoIcon altText="" />
          <ReactTooltip id={tooltipId} place="right" effect="solid">
            <TooltipContent>
              <LockWrap>
                <LockIcon
                  color={colors.neutrals.white}
                  width={16}
                  height={16}
                  locked
                  altText=""
                />
              </LockWrap>
              <span>{tooltipText}</span>
            </TooltipContent>
          </ReactTooltip>
        </InfoWrap>
      </Row>
    </div>
    {explanation ? (
      <div className="small-12 columns">
        <Typography.Text className="explanation">{explanation}</Typography.Text>
      </div>
    ) : null}
  </>
);

export default PodLockedToggle;
